import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { Field } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { RadioselectInput } from '@/components/inputs';
import { StepSection } from '../StepSection';
import { FIELD_EVENT_TYPE, EVENT_TYPE_VALUES, EventType } from '../InsuranceReportForm.types';
export const EventTypeStep = () => {
  const $ = _c(8);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["insuranceReport", "core"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  let t1;
  if ($[1] !== t) {
    t1 = t("insuranceReport:form.eventType.title");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t) {
    t2 = <Field name={FIELD_EVENT_TYPE} validate={value => !value || value.length === 0 ? t("core:forms.error.required") : undefined}>{fieldRenderProps => <RadioselectInput {...fieldRenderProps} options={[{
        label: t("insuranceReport:form.eventType.field.options.damage"),
        value: EVENT_TYPE_VALUES.DAMAGE
      }, {
        label: t("insuranceReport:form.eventType.field.options.theft"),
        value: EVENT_TYPE_VALUES.THEFT
      }, {
        label: t("insuranceReport:form.eventType.field.options.warranty"),
        value: EVENT_TYPE_VALUES.WARRANTY
      }]} />}</Field>;
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <StepSection title={t1} anchorKey="insuranceReport.form.eventType.title">{t2}</StepSection>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};